var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb ft16"},[_c('span',{staticClass:"flag"}),_c('div',{staticClass:"navt"},[_vm._t("parentsMenu")],2),_c('div',{staticClass:"navt"},[_vm._t("breadcrumb")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }